// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
    outline: none;
    list-style-type: none;
    text-decoration: none;
    background-color: transparent;
    font-weight: 400;
}

*::-webkit-scrollbar {
    width: 7px;
    height: 7px;
}

*::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px #eeeeee;
    border-radius: 8px;
}

*::-webkit-scrollbar-thumb {
    background-color: #d1d2d2;
    outline: 1px solid #d1d2d2;
    border-radius: 8px;
}

button {
    cursor: pointer;
}

a {
    color: rgba(24, 144, 255, 1);
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield;
}

#root {
    position: relative;
}

.ant-badge-count {
    z-index: 1000 !important;
}

.ant-popover {
    max-width: 400px;
}

.ant-popover-inner {
    padding: 0 !important;
    border-radius: 15px !important;
}

.ant-popover-inner-content {
    padding: 0 8px;
}

.ant-popover-title {
    padding: 20px 0 0 25px;
    margin-bottom: 0 !important;
}

.ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.ant-modal-footer {
    padding: 15px;
}

.ant-drawer-title {
    font-size: 20px !important;
}

.ant-popconfirm-inner-content {
    padding: 20px;
}

.ant-popconfirm-buttons {
    text-align: center !important;
}

.ant-modal-content {
    border-radius: 20px !important;
    padding: 0 !important;
}

@media (max-width: 470px) {
    .ant-picker-panels {
        flex-direction: column !important;
    }
}

.ant-tabs-nav-wrap::before,
.ant-tabs-nav-wrap::after {
    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/_custom.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;;IAEI,2BAA2B;AAC/B","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    outline: none;\n    list-style-type: none;\n    text-decoration: none;\n    background-color: transparent;\n    font-weight: 400;\n}\n\n*::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n}\n\n*::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px #eeeeee;\n    border-radius: 8px;\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: #d1d2d2;\n    outline: 1px solid #d1d2d2;\n    border-radius: 8px;\n}\n\nbutton {\n    cursor: pointer;\n}\n\na {\n    color: rgba(24, 144, 255, 1);\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n}\n\n#root {\n    position: relative;\n}\n\n.ant-badge-count {\n    z-index: 1000 !important;\n}\n\n.ant-popover {\n    max-width: 400px;\n}\n\n.ant-popover-inner {\n    padding: 0 !important;\n    border-radius: 15px !important;\n}\n\n.ant-popover-inner-content {\n    padding: 0 8px;\n}\n\n.ant-popover-title {\n    padding: 20px 0 0 25px;\n    margin-bottom: 0 !important;\n}\n\n.ant-modal-body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.ant-modal-footer {\n    padding: 15px;\n}\n\n.ant-drawer-title {\n    font-size: 20px !important;\n}\n\n.ant-popconfirm-inner-content {\n    padding: 20px;\n}\n\n.ant-popconfirm-buttons {\n    text-align: center !important;\n}\n\n.ant-modal-content {\n    border-radius: 20px !important;\n    padding: 0 !important;\n}\n\n@media (max-width: 470px) {\n    .ant-picker-panels {\n        flex-direction: column !important;\n    }\n}\n\n.ant-tabs-nav-wrap::before,\n.ant-tabs-nav-wrap::after {\n    box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
